import React from 'react';
import { translations } from '../../Common/Translations';
import { Link, withRouter } from 'react-router-dom';
import LocalizedStrings from 'react-localization';

import { getSinglePatient } from '../epics-patients';
import localStorage from '../../Common/LocalStorage';
import { RoutePaths } from '../../Common/ClientRoutes';
import Svgs from '../../Common/Svgs';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

const DEFAULT_DETAILS = {
    id: '',
    QRcode: '',
    name: '',
    address: '',
    birthDate: '',
    email: '',
    phone: '',
    insuranceCard: '',
    secondaInsuranceCard: '',
    pharmacy: ''
};

class PatientDetailsPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details: DEFAULT_DETAILS
        };
    }

    getPatientId = () => {
        const url = this.props.location.pathname;
        return url.split('/').slice(3, 4);
    };

    componentDidMount() {
        getSinglePatient(this.getPatientId())
            .then(res => {
                this.setState({
                    details: {
                        id: res.id,
                        QRcode: res.QRlink,
                        name: res.name,
                        address: res.address.name,
                        birthDate: res.dateOfBirth,
                        email: res.email,
                        phone: res.phone,
                        insuranceCard: res.insuranceCards.primaryCardNumber ? res.insuranceCards.primaryCardNumber : 'Not set yet',
                        secondaInsuranceCard: res.insuranceCards.secondaryCardNumber
                            ? res.insuranceCards.secondaryCardNumber
                            : 'Not set yet',
                        pharmacy: res.pharmacy.name
                    }
                });
            })
            .catch(() => {
                this.setState({
                    details: DEFAULT_DETAILS
                });
            });
    }

    render() {
        return (
            <div>
                <div className="container hide-for-print">
                    <div className="row qf-mb-100">
                        <div className="col-1 light-blue-bg text-center pt-3">
                            <span className="qf-page-icon">{Svgs.patients}</span>
                        </div>
                        <div className="col-11 white-bg px-5">
                            <div className="row remove-for-print">
                                <div className="col-9">
                                    <h2 className="qf-page-title text-capitalize">
                                        <i className="fa fa-plus-square mr-2" />
                                        {strings.Patient_info}
                                    </h2>
                                </div>
                                <div className="col-3 align-self-center text-right">
                                    <Link to={RoutePaths.PATIENT_DETAILS(this.getPatientId())} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <hr className="qf-divider-line" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-7">
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.patient_name_placeholder}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">{this.state.details.name}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.Birthday}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">{this.state.details.birthDate}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.patient_insurance_card_placeholder}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">{this.state.details.insuranceCard}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.patient_insurance_card_2_placeholder}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">
                                            {this.state.details.secondaInsuranceCard}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.Email}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">{this.state.details.email}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.phone}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">{this.state.details.phone}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.address}</div>
                                        <div className="col-12 color-light-blue mb-1 qf-big-text">{this.state.details.address}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 color-dark-gray">{strings.Pharmacy}</div>
                                        <div className="col-12 color-light-blue mb-5 qf-big-text">{this.state.details.pharmacy}</div>
                                    </div>
                                </div>

                                <div className="col-5">
                                    <div className="qf-qr-container">
                                        <div className="qf-qr-title-container mb-1">
                                            <span className="qf-qr-title color-dark-gray">{strings.generate_QR_code}</span>
                                        </div>
                                        <div className="qf-qr-image-container">
                                            <img className="qf-qr-image" src={this.state.details.QRcode} alt="" />
                                        </div>
                                        <div className="qf-qr-print-container">
                                            <div className="qf-print-btn">
                                                <span className="qf-medium-text color-light-blue" onClick={() => window.print()}>
                                                    <i className="fa fa-print mr-2" />
                                                    {strings.print_QR_code}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container print-container for-print">
                    <div className="row">
                        <div className="col-12 white-bg px-5">
                            <div className="row">
                                <div className="col-4 offset-1">
                                    <h2 className="qf-page-title text-capitalize print-title">
                                        <i className="fa fa-h-square mr-2" />
                                        {this.state.details.pharmacy}
                                    </h2>
                                </div>
                                <div className="col-4 offset-1">
                                    <h2 className="qf-page-title text-capitalize print-title">
                                        <i className="fa fa-phone-square mr-2" />
                                        {this.state.details.phone}
                                    </h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <hr className="qf-divider-line print-line" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="qf-qr-container">
                                        <div className="qf-qr-title-container mb-5">
                                            <span className="content-text">
                                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis culpa eos laboriosam
                                                saepe, veritatis voluptatem voluptatum. Dolor harum ipsum itaque labore neque quam quo
                                                recusandae rerum sed voluptate? Quis, rem!
                                            </span>
                                        </div>

                                        <div className="qf-qr-title-container mb-1">
                                            <span className="qf-qr-title color-dark-gray qr-title">{strings.scan_QR_code}</span>
                                        </div>
                                        <div className="qf-qr-image-container">
                                            <img className="qf-qr-image qr-image" src={this.state.details.QRcode}alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PatientDetailsPrint);



// WEBPACK FOOTER //
// ./src/customModules/Patients/components/Print-Details.js